import { addMonths } from "date-fns";

export default function stringToDate(value?: string, currentLanguage: string = "pt") : Date | undefined {
	if(!value || value.trim().length === 0)
		return undefined;
	
	const dateSplitted = value.split("/").map((val: string) => Number(val));
	const year = dateSplitted[2];
	let day = dateSplitted[0];
	let month = dateSplitted[1];

	if(currentLanguage === "en"){
		day = dateSplitted[1];
		month = dateSplitted[0];
	}

	const date = addMonths(new Date(year, month, day), -1);
	return date;
}
